import React from 'react';
import './wrap.scss';
export function ControlWrap({ label, children, className, labelClassName, message, valid, required, highlighted }) {
    const isValid = valid !== undefined ? valid : true;
    return React.createElement("div", { className: `ltg-control-wrap${className ? ` ${className}` : ''}${isValid ? '' : ' --invalid'}${required ? ' --required' : ''}${highlighted ? ' --highlighted' : ''}` },
        label && React.createElement("div", { className: `ltg-control-label${labelClassName ? ` ${labelClassName}` : ''}` }, label),
        children,
        message && React.createElement("div", { className: "ltg-control-message" }, message));
}
